/* Soap Supply lye calculator (NaOH, bar soap). SAP values = NaOH per unit oil (KOH SAP / 1.403). */
(function () {
  'use strict';
  var OILS = [
    ['Olive oil', 0.135], ['Coconut oil (76°)', 0.183], ['Palm oil', 0.142], ['Castor oil', 0.128],
    ['Shea butter', 0.128], ['Cocoa butter', 0.137], ['Mango butter', 0.137], ['Sweet almond oil', 0.139],
    ['Avocado oil', 0.133], ['Sunflower oil', 0.135], ['Rice bran oil', 0.128], ['Canola oil', 0.133],
    ['Grapeseed oil', 0.129], ['Hemp seed oil', 0.138], ['Apricot kernel oil', 0.139], ['Babassu oil', 0.175],
    ['Palm kernel oil', 0.176], ['Jojoba oil', 0.066], ['Lard', 0.141], ['Tallow (beef)', 0.143], ['Beeswax', 0.069]
  ];
  function el(tag, attrs, html) { var e = document.createElement(tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (html != null) e.innerHTML = html; return e; }
  function init(root) {
    var box = root.querySelector('[data-ss-calc]');
    if (!box || box.hasAttribute('data-bound')) return;
    box.setAttribute('data-bound', '');
    var rows = box.querySelector('[data-rows]');
    var unitSel = box.querySelector('[data-unit]');
    var sfIn = box.querySelector('[data-superfat]');
    var ratioSel = box.querySelector('[data-ratio]');
    var foIn = box.querySelector('[data-fo]');
    var warn = box.querySelector('[data-warn]');
    function addRow(name, w) {
      var tr = el('tr');
      var sel = el('select', { 'aria-label': 'Oil' });
      OILS.forEach(function (o, i) { var op = el('option', { value: i }); op.textContent = o[0]; if (o[0] === name) op.selected = true; sel.appendChild(op); });
      var inp = el('input', { type: 'number', min: '0', step: '0.1', inputmode: 'decimal', 'aria-label': 'Weight', value: w });
      var pct = el('span', { 'class': 'ss-pct' }, '0%');
      var rm = el('button', { type: 'button', 'class': 'ss-icon-btn', 'aria-label': 'Remove oil' }, '&times;');
      var td1 = el('td'); td1.appendChild(sel);
      var td2 = el('td'); td2.appendChild(inp);
      var td3 = el('td'); td3.appendChild(pct);
      var td4 = el('td'); td4.appendChild(rm);
      tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4);
      rows.appendChild(tr);
      sel.addEventListener('change', calc); inp.addEventListener('input', calc);
      rm.addEventListener('click', function () { tr.remove(); calc(); });
    }
    function fmt(v) { var u = unitSel.value; return (u === 'g' ? v.toFixed(0) : v.toFixed(2)) + ' ' + u; }
    function calc() {
      var total = 0, lye = 0, trs = rows.querySelectorAll('tr');
      var sf = Math.min(20, Math.max(0, parseFloat(sfIn.value) || 0)) / 100;
      trs.forEach(function (tr) {
        var w = Math.max(0, parseFloat(tr.querySelector('input').value) || 0);
        var sap = OILS[parseInt(tr.querySelector('select').value, 10)][1];
        total += w; lye += w * sap;
      });
      trs.forEach(function (tr) {
        var w = Math.max(0, parseFloat(tr.querySelector('input').value) || 0);
        tr.querySelector('.ss-pct').textContent = total ? Math.round(w / total * 100) + '%' : '0%';
      });
      lye = lye * (1 - sf);
      var water = lye * parseFloat(ratioSel.value);
      var fo = total * (Math.min(8, Math.max(0, parseFloat(foIn.value) || 0)) / 100);
      var batch = total + lye + water + fo;
      var ozBatch = unitSel.value === 'g' ? batch / 28.3495 : batch;
      box.querySelector('[data-r="lye"]').textContent = fmt(lye);
      box.querySelector('[data-r="water"]').textContent = fmt(water);
      box.querySelector('[data-r="oils"]').textContent = fmt(total);
      box.querySelector('[data-r="fo"]').textContent = fmt(fo);
      box.querySelector('[data-r="total"]').textContent = fmt(batch);
      box.querySelector('[data-r="bars"]').textContent = Math.floor(ozBatch / 4.5);
      var msg = '';
      if (sf * 100 < 3) msg = 'A superfat under 3% can leave a harsh bar. Most recipes use 5–8%.';
      trs.forEach(function (tr) {
        var name = OILS[parseInt(tr.querySelector('select').value, 10)][0];
        var w = parseFloat(tr.querySelector('input').value) || 0;
        if (/Coconut|Palm kernel|Babassu/.test(name) && total && w / total > 0.35) msg = msg || 'Over 35% coconut, palm kernel or babassu can be drying. Consider raising your superfat.';
        if (/Castor/.test(name) && total && w / total > 0.12) msg = msg || 'Over 12% castor oil can make bars soft and sticky.';
      });
      warn.textContent = msg;
    }
    box.querySelector('[data-add]').addEventListener('click', function () { addRow('Sweet almond oil', 0); calc(); });
    unitSel.addEventListener('change', function () {
      var toG = unitSel.value === 'g';
      rows.querySelectorAll('input').forEach(function (i) { var v = parseFloat(i.value) || 0; i.value = toG ? Math.round(v * 28.3495) : (v / 28.3495).toFixed(2); });
      calc();
    });
    [sfIn, ratioSel, foIn].forEach(function (x) { x.addEventListener('input', calc); x.addEventListener('change', calc); });
    addRow('Olive oil', 19.2); addRow('Coconut oil (76°)', 9.6); addRow('Castor oil', 3.2);
    calc();
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
